import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Global error handler
window.addEventListener('error', (e) => {
  console.error('Global error:', e.error);
  document.body.innerHTML = `<div style="padding: 20px; color: white; background: #1a1a1a;">
    <h2>Error Loading App</h2>
    <pre style="color: #ff6b6b; white-space: pre-wrap;">${e.error?.message || e.message}</pre>
    <pre style="color: #999; font-size: 12px;">${e.error?.stack || ''}</pre>
  </div>`;
});

// Disable right-click and text selection for better mobile experience
document.addEventListener('contextmenu', (e) => e.preventDefault());

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('❌ Failed to mount React app:', error);
  document.body.innerHTML = `<div style="padding: 20px; color: white; background: #1a1a1a;">
    <h2>Failed to Start</h2>
    <pre style="color: #ff6b6b;">${error}</pre>
  </div>`;
}
